import { Segmented } from "antd";
import React, { useState } from "react";
import ManageBatchesMain from "./batches/ManageBatchesMain";
import ManageStudentsMain from "./manageStudents/ManageStudentsMain";
import Utils from "../../../utils/Utils";

const userDetail = Utils.getUserDetail();

function OrgAdminStudentsMain({ setLoading }) {
  const [tab, setTab] = useState("manageBatches");

  return (
    <div className="px-5">
      <div className="mt-3 flex justify-start items-start">
        <Segmented
          options={[
            {
              label: "Manage Batches",
              value: "manageBatches",
            },
            {
              label: "Manage Students",
              value: "manageStudents",
            },
          ]}
          block
          className="max-w-[400px] w-full"
          onChange={(value) => {
            setTab(value);
          }}
        />
      </div>

      <div>
        {tab === "manageBatches" && (
          <ManageBatchesMain userDetail={userDetail} setLoading={setLoading} />
        )}

        {tab === "manageStudents" && <ManageStudentsMain />}
      </div>
    </div>
  );
}

export default OrgAdminStudentsMain;
